import { creatorbase } from '@round/api';
import { showNotification } from 'helpers';
import { copyPostUrlsToClipboardTable } from 'Modules/Plans/CopyToClipboard/PostUrlTable';
import { useEnsureProjectDetailsYoutubePosts } from '../posts/useProjectDetailsYoutubePosts';

export default function useCopyYoutubePostUrlsToClipboard() {
    const ensurePosts = useEnsureProjectDetailsYoutubePosts();

    return async (campaigns: creatorbase.Campaign[]) => {
        try {
            // The clipboard table keeps only live posts, so reading every status per
            // campaign matches the legacy active-posts read it replaces.
            const posts = (await Promise.all(campaigns.map((campaign) => ensurePosts(campaign.id)))).flat();
            const success = copyPostUrlsToClipboardTable(campaigns, posts);
            showNotification(success ? 'Copied!' : 'Could not copy', success ? 'info' : 'error');
        } catch {
            showNotification('Could not copy', 'error');
        }
    };
}
